const detectVideoSupplier = {
    isYT(url) {
        const yt = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        return (url.match(yt)) ? RegExp.$1 : false;
    },
    isVimeo(url) {
        const vimeo = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
        return (url.match(vimeo)) ? RegExp.$5 : false;
    },
    isWistia(url) {
        const wistia = /(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/;
        return (url.match(wistia)) ? RegExp.$1 : false;
    }
}

export default detectVideoSupplier;
